import { CHANGE_LANGUAGE } from "./constants";

function changeLanguageRequest(language) {
  return {
    type: CHANGE_LANGUAGE,
    payload: {
      language
    }
  };
}
export function changeLanguage(language) {
  return dispatch => {
    dispatch(changeLanguageRequest(language));
    localStorage.setItem("language", language);
  };
}



// WEBPACK FOOTER //
// ./src/modules/preference/actions.js